import { WildNavigationType } from "../../../../../../data/enums/navigation_type";
import { FeaturesComponentListData } from "../../FeaturesData";

export const sailingSchoolListData: FeaturesComponentListData = {
  image: "https://firebasestorage.googleapis.com/v0/b/wild-live.appspot.com/o/v2%2Fimagesforbrochuresite%2Fsailing-club.jpg?alt=media&token=dd32bf75-140b-43cc-a4c5-24ce4e725bfd",
  title: "Sailing School",
  subtitle: "It's Smooth Sailing From Here.",
  page: WildNavigationType.SAILINGSCHOOL,
}